import { useTranslation } from 'react-i18next'

import { Button } from '@maxus/website/components'
import { publicAssetUrl } from '@maxus/website/constants'
import { relayTicketToDesktop } from '@maxus/website/lib'

// 外部系统浏览器落地页：飞书 SSO 完成、后端回跳带 ?ticket&desktop=1 时展示。
// 挂载即由 useDesktopLoginRelay 自动深链接回传；此页提供兜底手动按钮（深链接未触发/被拦截时）。
const DesktopReturnPage = () => {
  const { t } = useTranslation()

  const handleReopen = () => {
    const ticket = new URLSearchParams(window.location.search).get('ticket')
    if (ticket) relayTicketToDesktop(ticket)
  }

  return (
    <main className="grid min-h-screen place-items-center bg-[#080a0f] text-text-primary">
      <section className="flex w-[360px] max-w-[calc(100vw-48px)] flex-col items-center gap-6 text-center">
        <img alt="Maxus" className="size-[52px] rounded-[12px] object-contain" src={publicAssetUrl('logo.png')} />
        <div className="flex flex-col gap-2">
          <h1 className="text-lg font-semibold">{t('Signed in successfully')}</h1>
          <p className="text-sm text-text-secondary">{t('Returning to the Maxus desktop app…')}</p>
        </div>
        <Button className="h-11 w-full rounded-md" onClick={handleReopen}>
          {t('Open desktop app')}
        </Button>
        <p className="text-xs text-text-tertiary">{t('You can close this page after returning to the app.')}</p>
      </section>
    </main>
  )
}

export { DesktopReturnPage }
